(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-zishiying"] && !Shopify.designMode) return;
  try {
    
// 此section的自适应逻辑完全由CSS实现，无需JavaScript
// 如果未来需要添加交互功能，可以在这里编写

  } catch(e) { console.error(e); }
})();
})();
